module.exports = __webpack_public_path__ + "img/worksbot_img19112518.f8d5ea7c.jpg";